<script>
  import Viz from "./components/__VIZ__.svelte";
  import { tick, setContext, onMount, afterUpdate } from "svelte";
  let data = [];
  let props = {};
  let viz;
  let key = {}; //identifier for events sent from self;
  //wraps a postMessage event payload with a type, used for identifying
  //messages from this source in a parent context
  const event = (payload) => {
    return {
      type: "viz",
      payload,
    };
  };
  export const resize = async (e) => {
    await tick();
    let scrollHeight = document.documentElement.offsetHeight;
    let scrollWidth = document.documentElement.scrollWidth;
    window.parent.window !== window &&
      window.parent.postMessage(
        event({
          innerHeight: scrollHeight,
          innerWidth: scrollWidth,
          key,
        }),
        "*"
      );
  };
  const signal_ready = () => {
    window.parent.window !== window &&
      window.parent.postMessage(event("ready"), "*");
  };
  const receive_message = (e) => {
    let sent_from_self = e.data.key === key;
    if (!sent_from_self) {
      e.data.data && ({ data } = e.data);
      e.data.props && ({ props } = e.data);
    }
  };

  setContext("resize", resize);

  onMount(async () => {
    await tick();
    signal_ready();
  });

  afterUpdate(async () => {
    await tick();
    resize();
  });
</script>

<svelte:window on:resize={resize} on:message={receive_message} />
<div class="main-container" bind:this={viz}>
  <Viz bind:data {...props} />
</div>
